import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { BTBusRouteRequest } from "../../shared/BTBusRouteRequest";
import { DataService_BusTrackerBusMaintenance } from "../../shared/data.service";

@Component({
	selector: "app-route-modify",
	templateUrl: "./route-modify.component.html",
	styleUrls: ["./route-modify.component.css"],
})
export class RouteModifyComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private routeService: DataService_BusTrackerBusMaintenance
	) {}

	ngOnInit(): void {
		this.EditMode = this.dialogConfig.data.EditMode;
		this.SelectedBus = this.dialogConfig.data.SelectedBus;
		this.Imported = this.dialogConfig.data.Imported;

		this.BusNbr = this.SelectedBus.BusNbr;
		this.BusDesc = this.SelectedBus.BusDesc;

		if (this.EditMode == true) {
			this.BusRouteID = this.dialogConfig.data.BusRouteID;
			// this.BusRouteTypeID = this.dialogConfig.data.BusRouteTypeID;
			this.BusRouteNbr = this.dialogConfig.data.BusRouteNbr;
			this.BusRouteDesc = this.dialogConfig.data.BusRouteDesc;
			this.BusRouteMisc1 = this.dialogConfig.data.BusRouteMisc1;
			this.BusRouteMisc2 = this.dialogConfig.data.BusRouteMisc2;
			this.DefinedByID = this.dialogConfig.data.DefinedByID;
			this.isAllowGuestRider = this.dialogConfig.data.isAllowGuestRider;
		}

		this.loadRouteType();
	}

	//////////////////////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////////////////////

	EditMode: any = false;
	Imported: any = false;

	SelectedBus: any;
	BusNbr: any = "";
	BusDesc: any = "";
	DefinedByID: any;

	BusRouteID: any = -1;

	BusRouteTypeID: any = 0;
	lstBusRouteType: any = [];

	BusRouteNbr: any = "";
	BusRouteDesc: any = "";
	BusRouteMisc1: any = "";
	BusRouteMisc2: any = "";

	isAllowGuestRider: any = false;

	errorMessage: any = "";

	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////////////////////////
	loadRouteType() {
		var result = this.routeService.BusRouteTypeSelectList();
		result.subscribe(
			(response) => {
				this.lstBusRouteType = response;

				this.BusRouteTypeID = this.lstBusRouteType[0].BusRouteTypeID;

				if (this.EditMode == true) {
					this.BusRouteTypeID = this.dialogConfig.data.BusRouteTypeID;
				}
			},
			(error) => {}
		);
	}
	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		if (this.BusRouteNbr == "") {
			this.errorMessage = "Enter a Route Number";
			return;
		}
		if (this.BusRouteDesc == "") {
			this.errorMessage = "Enter a Route Name/Description";
			return;
		}

		if (this.BusRouteNbr.length > 20) {
			this.errorMessage = "Route Number must be <= 20 characters";
			return;
		}
		if (this.BusRouteDesc.length > 100) {
			this.errorMessage = "Route Description must be <= 100 characters";
			return;
		}
		if (this.BusRouteMisc1.length > 256) {
			this.errorMessage = "Comments 1 must be <= 256 characters";
			return;
		}
		if (this.BusRouteMisc2.length > 256) {
			this.errorMessage = "Comments 2 must be <= 256 characters";
			return;
		}

		//
		// Create Request
		//
		let parms: BTBusRouteRequest = {
			BusRouteID: -1,
			BusRouteTypeID: this.BusRouteTypeID,
			BusRouteNbr: this.BusRouteNbr,
			BusRouteDesc: this.BusRouteDesc,
			BusRouteMisc1: this.BusRouteMisc1,
			BusRouteMisc2: this.BusRouteMisc2,
			BusID: this.SelectedBus.BusID,
			DefinedByID: 4,
			isAllowGuestRider: this.isAllowGuestRider == true ? 1 : 0,
		};

		//
		// Call SP
		//
		var result = this.routeService.BusRouteInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Route was created successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the Route",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onUpdate() {
		this.errorMessage = "";

		if (this.BusRouteNbr == "") {
			this.errorMessage = "Enter a Route Number";
			return;
		}
		if (this.BusRouteDesc == "") {
			this.errorMessage = "Enter a Route Name/Description";
			return;
		}

		if (this.BusRouteNbr.length > 20 && this.Imported == true) {
			this.errorMessage = "Route Number must be <= 20 characters";
			return;
		}
		if (this.BusRouteDesc.length > 100) {
			this.errorMessage = "Route Description must be <= 100 characters";
			return;
		}
		if (this.BusRouteMisc1.length > 256) {
			this.errorMessage = "Comments 1 must be <= 256 characters";
			return;
		}
		if (this.BusRouteMisc2.length > 256) {
			this.errorMessage = "Comments 2 must be <= 256 characters";
			return;
		}

		//
		// Create Request
		//
		let parms: BTBusRouteRequest = {
			BusRouteID: this.BusRouteID,
			BusRouteTypeID: this.BusRouteTypeID,
			BusRouteNbr: this.BusRouteNbr,
			BusRouteDesc: this.BusRouteDesc,
			BusRouteMisc1: this.BusRouteMisc1,
			BusRouteMisc2: this.BusRouteMisc2,
			BusID: this.SelectedBus.BusID,
			DefinedByID: this.DefinedByID,
			isAllowGuestRider: this.isAllowGuestRider == true ? 1 : 0,
		};

		//
		// Call SP
		//
		var result = this.routeService.BusRouteUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Route was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Route",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////////////////////////////////////////////////
}
